// import { Input } from "@windmill/react-ui";

// const InputValue = ({
//   trigger,
//   register,
//   required,
//   maxLength,
//   minLength,
//   pattern,
//   defaultValue,
//   name,
//   label,
//   type,
//   placeholder,
//   currency,
//   product,
// }) => {
//   const validation = {
//     valueAsNumber: false,
//     required: required ? false : `${label} is required!`,
//     maxLength: {
//       value: maxLength,
//       message: `Maximum Length ${maxLength}!`,
//     },
//     minLength: {
//       value: minLength,
//       message: `Minimum Length ${minLength}!`,
//     },

//     pattern: {
//       value: pattern,
//       message: `Invalid ${label}!`,
//     },
//   };

//   return (
//     <>
//       <div className={`flex flex-row`}>
//         {product && (
//           <span className="inline-flex items-center px-3 rounded rounded-r-none border border-r-0 border-white-300 bg-white-50 text-white-500 text-sm focus:bg-white focus:border-green-300 dark:bg-white-700 dark:text-white-300 dark:border dark:border-white-600">
//             {currency}
//           </span>
//         )}
//         <Input
//           {...register(`${name}`, validation)}
//           defaultValue={defaultValue}
//           type={type}
//           placeholder={placeholder}
//           name={name}
//           autoComplete="off"
//           onBlur={() => trigger(`${name}`)}
//           className={`border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white ${
//             product && "rounded-l-none"
//           }`}
//         />
//       </div>
//     </>
//   );
// };

// export default InputValue;


import { Input } from "@windmill/react-ui";

const InputValue = ({
  trigger,
  register,
  required,
  maxLength,
  minLength,
  pattern,
  defaultValue,
  name,
  label,
  type,
  placeholder,
  currency,
  product,
  disabled,
}) => {
  const validation = {
    valueAsNumber: false,
    required: required ? false : `${label} is required!`,
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength}!`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength}!`,
    },
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
  };

  return (
    <>
      <div className="flex flex-row">
        {product && (
          <span className="inline-flex items-center px-3 rounded rounded-r-none border border-r-0 border-white-300 bg-white-50 text-white-500 text-sm focus:bg-white focus:border-green-300 dark:bg-white-700 dark:text-white-300 dark:border dark:border-white-600">
            {currency}
          </span>
        )}

        <Input
          {...register(`${name}`, validation)}
          defaultValue={defaultValue}
          type={type}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          autoComplete="off"
          onBlur={() => trigger(`${name}`)}
          className={`border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white ${
            product && "rounded-l-none"
          }`}
        />
      </div>
    </>
  );
};

export default InputValue;
